// Material Kit 2 React pages
import Downloads from "pages/Downloads";

export default function WebinarPage() {
  return <Downloads />;
}
